import React from "react";

type DonateProps = {
  isDarkMode: boolean;
};

export const Donate: React.FC<DonateProps> = ({ isDarkMode }) => (
  <div
    className={`flex h-full w-full flex-col items-center ${isDarkMode ? "text-white" : "text-brown"}`}
  >
    <div
      className={`mt-2 flex flex-col items-start justify-start rounded-lg border-2 ${isDarkMode ? "border-darkgreen bg-darkblue" : "border-brown bg-white "} w-[21.5rem] [box-shadow:inset_0_-2px_#342e2e]`}
    >
      <div className="flex flex-col items-center justify-center">
        <img src="/imgs/fp_penguin_idle.png" alt="" className="ml-1 h-32 w-36" />
        <h1 className="font-bold"> We love the pets </h1>
        <div className="flex flex-col items-start">
          <div className="mb-2 mt-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/darkpaw.svg" : "/imgs/paw.svg"}
              alt=""
              className="mb-[1.95rem] ml-1 mr-1 h-4 w-4"
            />
            <h2 className="text-xs font-semibold">
              fpanalytica will never be locked behind a paywall. <br /> If you wish to support
              operation costs or support in general, any amount helps
            </h2>
          </div>
          <div className="mb-2 mt-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/darkpaw.svg" : "/imgs/paw.svg"}
              alt=""
              className="mb-4 ml-1 mr-1 h-4 w-4"
            />
            <h2 className="text-xs font-semibold">
              fpanalytica.eth 0xf88887Be20965Dd77afD4433a2F4E8Dd8D052011
            </h2>
          </div>
          <div className="mb-2 mt-2 flex items-center">
            <img
              src={isDarkMode ? "/imgs/darkpaw.svg" : "/imgs/paw.svg"}
              alt=""
              className="ml-1 mr-1 h-4 w-4"
            />
            <h2 className="text-xs font-semibold">Thank you and keep your pets alive</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
);
